<template>
  <section class="hero-background">
    <swiper
      :loop="true"
      slides-per-view="auto"
      effect="fade"
      :autoplay="{ delay: 4000, disableOnInteraction: false }"
    >
      <swiper-slide
        v-for="(slide, index) in slides"
        :key="index"
        :style="
          `background: url(${slide});
        background-size: cover !important; 
        background-position: center !important; 
        background-repeat: no-repeat !important;`
        "
      />
    </swiper>
    <slot />
  </section>
</template>
<script>
import SwiperCore, { EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.scss";
import "swiper/components/effect-fade/effect-fade.scss";

SwiperCore.use([EffectFade, Autoplay]);

export default {
  name: "Hero",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
.swiper-container {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
}
.hero-background {
  grid-template-columns: repeat(2, 1fr);
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.9) 100%,
    transparent 450px
  );
  background-size: cover;
  position: relative;
}
@media (min-width: 768px) {
  .hero-background {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.9) 50%,
      transparent 50%
    );
  }
}
</style>
